<template>
    <div class="mt-2">
        <b-card class="mt-2">
            <h4>View Previous Attendance</h4>
            <b-skeleton-wrapper
                :loading="loading"
            >
                <template #loading>
                    <b-skeleton></b-skeleton>
                </template>
                <b-select
                    :options="attendanceSheetDates"
                    v-model="selectedDate"
                ></b-select>
            </b-skeleton-wrapper>
        </b-card>
        <AttendanceList
            :key="selectedDate"
            :students="students"
            :class_id="class_.id"
            :date="selectedDate"
            @loaded="selectDate"
        ></AttendanceList>
    </div>
</template>
<script>
import AttendanceList from '../attendance-views/AttendanceList.vue';
export default {
    props: {
        students: Array,
        class_: Object
    },
    data() {
        return {
            loading: true,
            selectedDate: null,
            studentAttendance: {},
            attendanceSheet: {},
            attendanceSheetDates: []
        };
    },
    mounted() {
        this.listAttendanceSheets();
    },
    methods: {
        selectDate({ date }) {
            this.selectedDate = date;
        },
        listAttendanceSheets() {
            this.loading = true;
            this.$api.get(
                "/api/teacher/list-attendance-sheets",
                {
                    params: {
                        class_id: this.class_.id
                    }
                }
            ).then(({ data: { attendanceSheets } }) => {
                if (attendanceSheets)
                    this.attendanceSheetDates = attendanceSheets.map((attendanceSheetDate) => {
                        return {
                            text: this.$moment(attendanceSheetDate).format("dddd, LL"),
                            value: attendanceSheetDate
                        };
                    });
                this.loading = false;
            });
        }
    },
    components: { AttendanceList }
}
</script>